// extracted by mini-css-extract-plugin
export default {"scrollButton":"ScrollButton_scrollButton__eucwP","scrollButtonImgOverlay":"ScrollButton_scrollButtonImgOverlay__C70Rg"};